import TableExpander from './TableExpander'

export default TableExpander
